import {Dashboard} from '../../components/splide'

const init = () => {
  Dashboard()
}

export default init
